import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Grid, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useListResponse } from '../../Context/ListResponse';
import { convertToPersianDate } from "../../helpers/ConvertDate";
import { convertToPersianTime } from "../../helpers/ConvertTime";
import Loading from '../Loading/Loading';
import { handleGetDetailsResponse } from '../../helpers/HandleGetDetailsResponse';
import { useDetailsResponse } from '../../Context/DetailsResponse';
import { useLoading } from '../../Context/LoadingContext';
import { useNavigate } from 'react-router-dom';

const ResponseFormList = () => {

    const { listResponse } = useListResponse();
    const { setDetailsResponse } = useDetailsResponse();
    const { setLoading } = useLoading()

    const [error, setError] = useState(null);

    const navigate = useNavigate()

    const handleGetDetailsResponseForm = (id) => {
        const { data, error } = handleGetDetailsResponse(id, setDetailsResponse , setLoading);
        if (error) setError(error);
        navigate(`/form/details-response-form/${id}`);
    }

    return (
        <>
            <Loading />
            <TableContainer component={Paper} sx={{ maxWidth: {xs:'90%' , md:'768px'}, mx: 'auto', mt: 4 , overflow:'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ fontSize: '12px' , minWidth:'fit-content' }}><strong>ID</strong></TableCell>
                            <TableCell align="center" style={{ fontSize: '12px' , minWidth:'fit-content' }}><strong>تاریخ تکمیل فرم</strong></TableCell>
                            <TableCell align="center" style={{ fontSize: '12px' , minWidth:'fit-content' }}><strong>زمان تکمیل فرم</strong></TableCell>
                            <TableCell align="center" style={{ fontSize: '12px' , minWidth:'fit-content' }}><strong>مشاهده جزییات پاسخ های فرم</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listResponse?.map((response, index) => (
                            <TableRow key={index} sx={{ cursor: 'pointer' }}>
                                <TableCell align="center" style={{ fontSize: '12px' }}>{response.id}</TableCell>
                                <TableCell align="center" style={{ fontSize: '12px' }}>{convertToPersianDate(response.submittedAt.split(' ')[0])}</TableCell>
                                <TableCell align="center" style={{ fontSize: '12px' }}>{convertToPersianTime(response.submittedAt.split(' ')[1])}</TableCell>
                                <TableCell align="center" style={{ fontSize: '12px' , display:'flex' , justifyContent:'center' }}>
                                    <Tooltip
                                        title={<Typography variant='subtitle1'>مشاهده جزئیات پاسخ فرم</Typography>}
                                        arrow>
                                        <Button sx={{
                                            display: 'flex',
                                            alignItems: "center",
                                            justifyContent: 'center',
                                            width: '24px',
                                            height: '48px',
                                            '&:hover': { variant: 'contained' }
                                        }} onClick={() => {
                                            handleGetDetailsResponseForm(response.id)
                                        }}>
                                            <Grid width={'100%'} height={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                                <Typography variant='subtitle1' fontWeight={700}>                                                
                                                    مشاهده
                                                </Typography>
                                            </Grid>
                                        </Button>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );
}

export default ResponseFormList;
